<main class="page">
    <cm-header-simple></cm-header-simple>
    <div class="page__content"><router-outlet></router-outlet></div>
</main>
